import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../contexts/AppContext";
import { Button } from "@velove/design-system";
import { Flex } from "theme-ui";

const CustomerSupport = () => {
  const { t } = useTranslation();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { partner, settings, trackingDetails } = useContext(AppContext);
  const [freshWidget, setFreshWidget] = useState<any>(undefined);
  const [scrollDown, setScrollDown] = useState(false);

  useEffect(() => {
    if ((window as any).fcWidget) {
      setFreshWidget((window as any).fcWidget);
    }
    if (freshWidget) {
      freshWidget.setConfig({
        content: {
          welcomeMessage: "Hur kan vi hjälpa till?",
        },
        headerProperty: {
          backgroundColor: settings?.brand?.color || "#6F7DFF",
        },
      });

      freshWidget.on("user:created", () => {
        freshWidget.user.setFirstName(
          trackingDetails?.package?.internalPackageId || "Test"
        );

        freshWidget.user.setProperties({
          cf_partner: settings?.displayName || partner?.name || "Velove",
          cf_internal_package_id:
            trackingDetails?.package?.internalPackageId || "Unknown",
          cf_hub: trackingDetails?.hubName || "Unknown",
        });
      });

      freshWidget.on("widget:opened", () => {
        freshWidget.user.setFirstName(
          trackingDetails?.package?.internalPackageId || "Test"
        );

        freshWidget.user.setProperties({
          cf_partner: settings?.displayName || partner?.name || "Velove",
          cf_internal_package_id:
            trackingDetails?.package?.internalPackageId || "Unknown",
          cf_hub: trackingDetails?.hubName || "Unknown",
        });
      });

      freshWidget.on("widget:closed", () => {
        setScrollDown(true);
      });
    }
  }, [freshWidget, trackingDetails, settings, partner]);

  useEffect(() => {
    if (scrollDown && buttonRef && buttonRef.current) {
      buttonRef.current.scrollIntoView({ inline: "end" });
    }
  }, [scrollDown]);

  return (
    <Flex
      sx={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
      }}
    >
      <Button
        ref={buttonRef}
        leadingIcon="Wave"
        variant="primarySystemGreen"
        sx={{
          fontWeight: 500,
          display: "flex",
          alignItems: "center",
          columnGap: "5px",
          backgroundColor: settings?.brand?.color || "#6F7DFF",
          mb: "25px",
        }}
        onClick={() => {
          if (freshWidget) {
            freshWidget.open();
            setScrollDown(false);
          }
        }}
      >
        {t("customer_support")}
      </Button>
    </Flex>
  );
};

export default CustomerSupport;
